import React, { Suspense, lazy } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "redux/store";


const UK = lazy(() => import("../../TermsAndConditionsUK/TermsAndConditions"));
const UKEP = lazy(() => import("../../TermsAndConditionsUK/TermsAndConditionsUKEP"));
const UKEPPTAC = lazy(() => import("../../TermsAndConditionsUK/PurchaserTermsAndConditionsUKEP"));
const UKSNTAC = lazy(() => import("../../TermsAndConditionsUK/SNTermsAndConditions"));
const AU = lazy(() => import("../Australia/TermsAndConditionsAU"));
const IE = lazy(() => import("../Ireland/TermsAndConditionsIE"));
const PT = lazy(() => import("../Portugal/TermsAndConditionsPT"));

const TermsAndConditionsLoader = () => {

    const region = useSelector((state: RootState) => state.region.region);

    const { source } = useParams();

    const getTermsComponent = () => {
        if (region === "UK") {
            if (source === "ep") return <UKEP />;
            if (source === "epptac") return <UKEPPTAC />;
            if (source === "sntac") return <UKSNTAC />;
            return <UK />;
        }

        if (region === "IE") return <IE />;
        if (region === "AU") return <AU />;
        if (region === "PT") return <PT />;
    };

    return (
        <Suspense fallback={<Spinner animation="border" variant="light" />}>
            {getTermsComponent()}
        </Suspense>
    );

}

export default TermsAndConditionsLoader;